<template>
    <div>
        <div class="Intro">
            <div class="title">
                <div class="BigTitle">{{ $t("Learn.token") }}</div>
                <div class="SubTitle">{{ $t("Learn.whatToken") }}</div>
                <div class="detail">{{ $t("Learn.detail2") }}</div>
            </div>
            <!-- 滑动 -->
            <div class="w1352 box-card box-card-p20">
                <swiper ref="mySwiper" :options="swiperOptions">
                    <swiper-slide class="img1">
                        <div class="item"></div>
                        <p class="level4title">{{ $t("Learn.way1") }}</p>
                    </swiper-slide>
                    <swiper-slide class="img2">
                        <div class="item"></div>
                        <p class="level4title">{{ $t("Learn.way2") }}</p>
                    </swiper-slide>
                    <swiper-slide class="img3">
                        <div class="item"></div>
                        <p class="level4title">{{ $t("Learn.way3") }}</p>
                    </swiper-slide>
                    <swiper-slide class="img4">
                        <div class="item"></div>
                        <p class="level4title">{{ $t("Learn.way4") }}</p>
                    </swiper-slide>
                    <swiper-slide class="img5">
                        <div class="item"></div>
                        <p class="level4title">{{ $t("Learn.way5") }}</p>
                    </swiper-slide>
                </swiper>
                <!-- 如果需要导航按钮 -->
                <div class="button-all">
                    <div class="swiper-button-prev" @click="prev()"></div>
                    <div class="swiper-button-next" @click="next()"></div>
                </div>
            </div>
        </div>
        <div class="Intro1">
            <div class="title tit2">
                <div class="BigTitle" style="margin-top:100px;">{{ $t("Learn.token1") }}</div>
                <div class="SubTitle">{{ $t("Learn.whatToken1") }}</div>
                <div class="detail">{{ $t("Learn.detail21") }}</div>
            </div>
            <div class="echartbox">
                <div id="boxs"  style="height:650px;"></div>
            </div>

            <div class="title tit1">

                <div class="SubTitle SubTitle1" >{{ $t("Learn.whatToken2") }}</div>
                <div class="echartbox">
                    <div id="boxss" class="echartcontent eco1"></div>
                </div>


            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper.less";
import { matrix } from "echarts";
let echarts = require("echarts");

export default {
  props: {
    blogList: {
      type: Array,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  // directives: {
  //   swiper: directive,
  // },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 3000,
        },
        slidesPerView: 3,
        loop: true,
        // spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      timer: null,
    };
  },
  mounted() {
    this.init();
    this.initechart();
    this.initechart1();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    init() {
      this.count = this.count++;
      this.timer = setInterval(() => {
        this.swiper.slideNext(500);
      }, 3000);
    },
    toolTipClose(e) {
      console.log(e);
      e.parentNode.style.display = "none"; //找到该元素父元素，设置display为none即可实现手动关闭
    },
    leftslide() {
      let myChart = echarts.init(document.getElementById("boxs"));
      console.log(myChart);
      myChart._dom.childNodes[1].style.display = 'none'
      const leir=myChart._dom.childNodes[1].innerHTML;
     // console.log( leir);
      //leir.style.display="none";
     // console.log(e);
     // alert(123);
    },
    initechart() {
      let myChart = echarts.init(document.getElementById("boxs"));
     // var datas = "";

      window.toolTipClose = this.toolTipClose;
      window.leftslide = this.leftslide;
     // console.log(myChart);
      var option;
      option = {
        // title: {
        //   text: 'Stacked Area Chart'
        // },

        tooltip: {
          show: true, //是否显示提示框组件，包括提示框浮层和 axisPointer。
          trigger: "axis",
          triggerOn: "mousemove|click",
         // triggerOn: "none",
          enterable: true,

          extraCssText: "z-index: 99;white-space:pre-wrap",
          hideDelay: 10,
          // formatter: function(params) {
          // 	// return params.name + ' : ' + params.value[2];
          // // οnclick="leftslide('+params+')"
          // 	var info ='<div class="main"><div class="leftpic" οnclick="leftslide()">sdfsfsf</div>'
          // 	return info;
          // }

          formatter: function (params) {
           // console.log(params);
          //  datas = params;
            // console.log(params);
            let res = "";
            let year = "";
            let name = "";
            let value = "";
            let marker = "";
            let seriesY = "";
            let zongliang = [];

            params.forEach((item) => {
              if (item.axisValue == 1) {
                year = "January";
              } else if (item.axisValue == 2) {
                year = "February";
              } else if (item.axisValue == 3) {
                year = "March";
              } else if (item.axisValue == 4) {
                year = "April ";
              } else if (item.axisValue == 5) {
                year = "May";
              } else if (item.axisValue == 6) {
                year = "June";
              } else if (item.axisValue == 7) {
                year = "July ";
              } else if (item.axisValue == 8) {
                year = "August ";
              } else if (item.axisValue == 9) {
                year = "September";
              } else if (item.axisValue == 10) {
                year = "October ";
              } else if (item.axisValue == 11) {
                year = "November ";
              } else if (item.axisValue == 12) {
                year = "December";
              } else if (item.axisValue == 2022) {
                year = "Before June";
              }
              name = "Month:" + year;
              marker = '<p style="text-align: left">' + item.marker;
              seriesY = item.seriesName;
              // if(seriesY.length < 10){
              //     seriesY +='&nbsp;'
              // }
              value = String(item.value).replace(/^(.*\..{10}).*$/, "$1");
              value = Number(value); // number = 12.3321
              zongliang.push(value);
              // zongliang +=value;
              // console.log(value);
              //   console.log(zongliang);

              value = "" + value + "M" + "</p>";

              // value = ''+ item.value + ' Million'+'</p>';
              res += marker + seriesY + ":" + value;
            });
            var d = 0;
            var sum = 0;
            for (var i = 0; i < zongliang.length; i++) {
              var str = "" + zongliang[i];
              if (str.indexOf(".") != -1) {
                var temp = str.split(".")[1].length;
                d = d < temp ? temp : d;
              }
            }
            var m = Math.pow(10, d);
            for (var i = 0; i < zongliang.length; i++) {
              sum += zongliang[i] * m;
            }

            return (res =
              '<div  style="display:block;" onclick="leftslide()">' +
              name +
              "<br />" +
             
              res +
              "</div>");
          },
        },

        legend: {
          //data: ['Seed round', 'Strategy round', 'Private round', 'IDO', 'Team'],
          //data:['Strategi cooperation','Airdrop', 'Team','Private round','Seed round', 'Strategy round',  'IDO'],
          data: [
            "technological development",
            "Community and operation",
            "Miner rewards",
            "Secondary circulation"
          ],
          icon: "rect", // 设置legend图标
          bottom: "bottom", //设置legend位置
          itemWidth: 30, // 设置宽度
          itemHeight: 6, // 设置高度
          itemGap: 60, //设置legend项之间的间距
          align: "left",

          formatter: ["{a|{name}}"].join("\n"),
          textStyle: {
            lineHeight: 6,
            fontSize: 15,
            fontWeight: 400,
            color: "#000",
            rich: {
              a: {
                padding: 4,
                lineHeight: 12,
              },
            },
          },
        },
        toolbox: {
          show: false, //工具消失
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          top: "7%",
          left: "2%",
          right: "2%",
          bottom: "16%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            data: [
              "2024",
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
            ],
            smooth: true, // 线条是否平滑
            symbol: "none", // 是否显示节点
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: 150,
            axisLine: {
              show: true, //y轴线消失
            },

            axisTick: {
              show: true, //y轴坐标点消失
            },
            axisLabel: {
              formatter: "{value} M",
            },
            // axisLabel: {
            // formatter: '{value}'
            // }
            // min: function(value){
            //     console.log(value);
            //     return value.min;
            // },
            // max:function(value){
            //     console.log(value);
            //     return value.max;
            // }
            // min:0,
            // max:400,
            //  splitNumber:400,
            // axisLabel:{
            //     formatter: function (value) {
            //         var texts = [];
            //         if(value==0){
            //             texts.push(' ');
            //         }
            //         else if (value <=100) {
            //             texts.push('100M');
            //             max:100;
            //         }
            //         else if (value<= 200) {
            //             texts.push('200M');
            //             max:200;
            //         }
            //         else if(value<= 300){
            //             texts.push('300M');
            //             max:300;
            //         }
            //         else{
            //             texts.push('400M');
            //             max:400;
            //         }
            //         return texts;
            //
            //     }
            // }
          },
        ],
        series: [
          {
            name: "technological development",
            type: "line",
            stack: "Total",

            lineStyle: {
              normal: {
                width: 0,
              },
            },

            showSymbol: false,
            smooth: true, // 线条是否平滑
            symbol: "none", // 是否显示节点
            areaStyle: {
              color: "#365EEC ",
            },
            itemStyle: {
              color: "#7594FF", //设置折线图颜色
              emphasis: {
                color: "#7594FF",
              },
            },
            data:[0,2.166658,2.333324,2.499990,2.666656,2.833322,2.999988,3.166654,3.333320,3.499986,3.666652,3.833318,3.999984]
           // data:[0,0.166666,0.333332,0.499998,0.666664,0.833330,0.999996,1.166662,1.333328,1.499994,1.666660,1.833326,2.000000]
        
          },
          {
            name: "Community and operation",
            type: "line",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#55699B",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: true, // 线条是否平滑
            symbol: "none", // 是否显示节点

            itemStyle: {
              color: "#AEDAFF", //设置折线图颜色
              emphasis: {
                color: "#AEDAFF",
              },
            },
            // emphasis: {
            //     focus: 'series'
            // },
            areaStyle: {
              color: "#6EB9FE",
            },
            data:[0,2.166658,2.333324,2.499990,2.666656,2.833322,2.999988,3.166654,3.333320,3.499986,3.666652,3.833318,3.999984]
             //data:[0,0.166666,0.333332,0.499998,0.666664,0.833330,0.999996,1.166662,1.333328,1.499994,1.666660,1.833326,2.000000]
           
          },
          {
            name: "Miner rewards",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#43D2FF",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            itemStyle: {
              color: "#7FEEFF", //设置折线图颜色
              emphasis: {
                color: "#7FEEFF",
              },
            },
            showSymbol: false,
            smooth: true, // 线条是否平滑
            symbol: "none", // 是否显示节点
            data:[0,0.3797847543,0.3812785743,0.38277827,0.3842838646,0.3857953811,0.3873128429,0.3888362734,0.3903656961,0.3919011345,0.3934426123,0.3949901533,0.3965437812
]
//             data:[0,0.7329060754,0.7380974935,0.7433256840,0.7485909076,0.7538934266,0.7592335050,0.7646114090,0.7700274065,0.7754817673,0.7809747631,0.7865066677,0.7920777566 

// ]
          
          },
          {
            name: "Secondary circulation",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#55699B",
            },
            itemStyle: {
              color: "#8D9DC3", //设置折线图颜色
              emphasis: {
                color: "#8D9DC3",
              },
            },

            smooth: true, // 线条是否平滑
            symbol: "none", // 是否显示节点
            data:[0,104.1576707543,104.8722813286,105.5883915986,106.3060074631,107.0251348442,107.7457796872,108.4679479606,
            109.1916456567,109.9168787912,110.6436534035,111.3719755568,112.1018513380 ]
          
//               data:[0,84.5353310754,85.9400925689,87.6834142529,89.7653331605,92.1858865871,94.9451120921,98.0430475011,101.4797309076,105.2552006749 
// ,109.3694954380,113.8226541057,118.6147158623 
//]
          },

    
        ],
      };

      //   myChart.getZr().on('click', function(params) {
      //      alert(123433);
      //      console.log(params);
      //       myChart._dom.childNodes[1].style.display = 'none'
      //     const leir=myChart._dom.childNodes[1].innerHTML;
      //     console.log( leir);
      //     leir.style.display="none";
      //   // 控制台打印数据的名称
      //   console.log(params.name);
      // });
    //  myChart.getZr().off();
      
      option && myChart.setOption(option);
     /* myChart.getZr().on('mouseout', function (param) {
         let pointInPixel = [param.offsetX, param.offsetY]
         let is_in = myChart.containPixel({seriesIndex: [6]}, pointInPixel );
       
          console.log(is_in);
      });*/
   var symbolSize = 20;
    let  datas = [
        [166.666,333.332,499.998,666.664,833.330,999.996,1166.662,1333.328,1499.994,1666.660,1833.326,1999.992],
        [166.666,333.332,499.998,666.664,833.330,999.996,1166.662,1333.328,1499.994,1666.660,1833.326,1999.992],
      [732.9060754,738.0974935,743.3256840,748.5909076,753.8934266,759.2335050,764.6114090,770.0274065,775.4817673,780.9747631,786.5066677 
],
       [84535.3310754,85940.0925689,87683.4142529,89765.3331605,92185.8865871,94945.1120921,98043.0475011,101479.7309076,105255.2006749 
,109369.4954380,113822.6541057]
        // [
        //   375, 447.916, 520.832666, 593.749332, 666.665998, 739.582664,
        //   812.49933, 885.415996, 958.332662, 1031.249328, 1104.165994,
        //   1177.08266, 1250,
        // ],
        // [
        //   600, 716.666, 833.332, 949.998, 1066.664, 1183.33, 1299.996, 1416.662,
        //   1533.328, 1649.994, 1766.66, 1883.326, 2000,
        // ],
        // [
        //   2000, 2250, 2500, 2750, 3000, 3250, 3500, 3750, 4000, 4000, 4000,
        //   4000, 4000,
        // ],
      ];




     // console.log(myChart);
      /*myChart.setOption({
        graphic: echarts.util.map(datas, function (item, dataIndex) {
         // console.log(item);
          console.log(myChart.convertToPixel("grid", item));
          return {
            type: "line",
            position: myChart.convertToPixel("grid", item),
            shape: {
              r: symbolSize / 2,
            },
            invisible: true,
            draggable: true,
           
            onmousemove: echarts.util.curry(showTooltip, dataIndex,myChart),
            onmouseout: echarts.util.curry(hideTooltip, dataIndex,myChart),
            z: 100,
          };
        }),
      });*/
      /*window.addEventListener("resize", function () {
        myChart.setOption({
          graphic: echarts.util.map(data, function (item, dataIndex) {
            return {
              position: myChart.convertToPixel("grid", item),
            };
          }),
        });
      });*/
    },
    initechart1() {
      let myChart = echarts.init(document.getElementById("boxss"));
      console.log(myChart);

      var option;
      option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let res = "";
            let name = "";
            let value = "";
            let marker = "";
            let seriesY = "";
            params.forEach((item) => {
              name = "Year  &nbsp; &nbsp;:&nbsp; &nbsp;" + item.name;
              marker = '<i style="text-align: left">' + item.marker + "</i>";
              // marker = item.marker;
              seriesY = item.seriesName;
              value = item.value + "%";
              res +=
                '<p style="text-align: left">' +
                marker +
                seriesY +
                "&nbsp;" +
                value +
                "</p>";
            });
            return (res = name + res);
          },
          //triggerOn: 'click',
          //   enterable: false,
          //    axisPointer: {  //坐标轴指示器，坐标轴触发有效，
          //       type: 'cross', //默认为line，line直线，cross十字准星，shadow阴影
          //       crossStyle: {
          //        color: 'red'
          //      },
          //      label:{
          //         formatter: function (params) {
          //           console.log(params.value);
          //           params.value+"%";
          //         }
          //      }
          // }

          //  formatter: function (params) {

          //  }

          //  axisPointer: {
          //       type: 'cross',
          //       label: {
          //         formatter: function (params) {
          //           console.log(params);
          //           if (params.seriesData.length === 0) {
          //             window.mouseCurValue = params.value;
          //           }
          //         }
          //       }
          //     },
          // formatter: function (params) {
          //     let res = '',
          //         sum =params[0].axisValue+'year'+'<br/>';
          //     for(var i=0;i < params.length; i++){
          //         // sum=params[0].axisValue;
          //         // console.log(sum);
          //         res +=
          //             params[i].marker+
          //             params[i].seriesName+
          //             '   '+
          //             params[i].data + '%' +//12
          //             '<br/>' ;
          //     }
          //     // sum+res
          //     // 先取消所有当前dataIndex点的高亮
          //     // var chartInstance =-1;
          //     // console.log(chartInstance);
          //
          //     // for (let i = 0; i < params.length; i++) {
          //     //   let series = params[i]; // 累计series.data，与mouseCurValue做比较，找出鼠标位置对应的series
          //     //   sum += Number(series.data);
          //     //   if (sum >= mouseCurValue) {
          //     //     res='<div style="display:flex;flex-direction:column;align-items: flex-start;">'+
          //     //     '<div>'+"Month："+series.axisValue+"月"+'</div>'+
          //     //      '<div>'+ series.seriesName+": "+series.marker+'</div>'+
          //     //       '<div>'+"Amount："+series.data+"Million"+'</div>'
          //     //     +'</div>'
          //     //     // res ='Month：'+
          //     //     //   series.axisValue + '月' +//12
          //     //     //   '<br/>' +
          //
          //     //     //   series.seriesName + ':' +//名字
          //     //     //   series.marker + //颜色
          //
          //     //     //   '<br/>'+
          //     //     //   'Amount：'+
          //     //     //   series.data +'Million' //值
          //     //     //   '<br/>';
          //     //     // 再高亮当前鼠标所在区域所代表的点
          //
          //     //     break;
          //     //   }
          //     // }
          //     return sum+res;
          // }
        },
        legend: {
          left: "60",
          bottom: 20,
          width: 1200, //给整个图例组件这只宽度,如果不设置,图例将根据容器大小自适应
          icon: "rect", // 设置legend图标
          bottom: "bottom", //设置legend位置
          itemWidth: 30, // 设置宽度
          itemHeight: 6, // 设置高度
          // itemGap: 60, //设置legend项之间的间距
          data: [
            "0%-25%",
            "25%-30%",
            "30%-35%",
            "35%-40%",
            "40%-45%",
            "45%-50%",
            "50%-55%",
            "55%-60%",
            "60%-65%",
            "65%-70%",
            "70%-75%",
            "75%-80%",
            "80%-85%",
          ],

          formatter: ["{a|{name}}"].join("\n"),
          textStyle: {
            lineHeight: 6,
            fontSize: 15,
            fontWeight: 400,
            color: "#000",
            rich: {
              a: {
                width: 95,
                padding: 4,
                lineHeight: 12,
              },
            },
          },
        },
        grid: {
          top: "7%",
          left: "2%",
          right: "2%",
          bottom: "22%",
          containLabel: true,
        },
        toolbox: {
          show: false, //工具消失
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
          ],
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 12,
          //splitNumber: 3, // 横线数
          interval: 1, // 刻度间隔
          axisLabel: {
            formatter: "{value} %-",
          },
        },
        series: [
          {
            name: "0%-25%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#5583FF ", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
             data: [8.5,7.65,6.8,5.95,5.10,4.25,3.40,2.55,1.70,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   12, 11.4, 10.8, 10.2, 9.6, 9.0, 8.4, 7.8, 7.2, 6.6, 6.0, 5.4, 4.8,
            //   4.2, 3.6, 3.0, 2.4, 1.8, 1.8,
            // ],
          },
          {
            name: "25%-30%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#94B1FC", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[7.86,7.01,6.16,5.31,4.46,3.61,2.76,1.91,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   11.51, 10.91, 10.31, 9.71, 9.11, 8.51, 7.91, 7.31, 6.71, 6.11,
            //   5.51, 4.91, 4.31, 3.71, 3.11, 2.51, 1.91, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "30%-35%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#CBD5EF", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[7.23,6.38,5.53,4.68,3.83,2.98,2.13,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   11.01, 10.41, 9.81, 9.21, 8.61, 8.01, 7.41, 6.81, 6.21, 5.61,
            //   5.01, 4.41, 3.81, 3.21, 2.61, 2.01, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "35%-40%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#CBD5EF", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[6.59,5.74,4.89,4.04,3.19,2.34,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   10.52, 9.92, 9.32, 8.72, 8.12, 7.52, 6.92, 6.32, 5.72, 5.12, 4.52,
            //   3.92, 3.32, 2.72, 2.12, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "40%-45%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#43D2FF", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[5.95,5.10,4.25,3.40,2.55,1.7,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   10.02, 9.42, 8.82, 8.22, 7.62, 7.02, 6.42, 5.82, 5.22, 4.62, 4.02,
            //   3.42, 2.82, 2.22, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "45%-50%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#6EB9FE", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[5.31,4.46,3.61,2.76,1.91,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   9.52, 8.92, 8.32, 7.72, 7.12, 6.52, 5.92, 5.32, 4.72, 4.12, 3.52,
            //   2.92, 2.32, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ], //
          },
          {
            name: "50%-55%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#365EEC", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[4.68,3.83,2.98,2.13,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   9.03, 8.43, 7.83, 7.23, 6.63, 6.03, 5.43, 4.83, 4.23, 3.63, 3.03,
            //   2.43, 1.83, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "55%-60%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#6EB9FE", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[4.04,3.19,2.34,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   8.53, 7.93, 7.33, 6.73, 6.13, 5.53, 4.93, 4.33, 3.73, 3.13, 2.53,
            //   1.93, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "60%-65%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#43D2FF", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[3.40,2.55,1.70,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   8.04, 7.44, 6.84, 6.24, 5.64, 5.04, 4.44, 3.84, 3.24, 2.64, 2.04,
            //   1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "65%-70%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#3F1698", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[2.76,1.91,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   7.54, 6.94, 6.34, 5.74, 5.14, 4.54, 3.94, 3.34, 2.74, 2.14, 1.8,
            //   1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "70%-75%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#CBD5EF", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[2.13,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   7.05, 6.45, 5.85, 5.25, 4.65, 4.05, 3.45, 2.85, 2.25, 1.8, 1.8,
            //   1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "75%-80%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#94B1FC", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
            data:[1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   6.55, 5.95, 5.35, 4.75, 4.15, 3.55, 2.95, 2.35, 1.8, 1.8, 1.8,
            //   1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
          {
            name: "80%-85%",
            type: "line",

            smooth: 0.1, // 线条是否平滑
            symbol: "none", // 是否显示节点
            itemStyle: {
              color: "#5583FF", //设置折线图颜色
            },
            lineStyle: {
              width: 1,
            },
             data:[1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50,1.50]
            // data: [
            //   6.06, 5.46, 4.86, 4.26, 3.66, 3.06, 2.46, 1.86, 1.8, 1.8, 1.8,
            //   1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
            // ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
    prev() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
   

    onPointDragging(dataIndex, dx, dy) {
      data[dataIndex] = myChart.convertFromPixel("grid", this.position);
      myChart.setOption({
        series: [
          {
            id: "a",
            data: data,
          },
        ],
      });
    },
    // detalis(blog) {
    //   this.$router.push({
    //     path: "/pc/Blog/Details",
    //     query: { id: blog.blogId },
    //   });
    // },
  },
  created() {},
};
function showTooltip(dataIndex,myChart) {
   console.log(dataIndex);
      myChart.dispatchAction({
        type: "showTip",
        seriesIndex: dataIndex,
        //dataIndex: dataIndex,
      });
    }

function    hideTooltip(dataIndex,myChart) {
  console.log(dataIndex);
      myChart.dispatchAction({
        type: "hideTip",
      //  seriesIndex: dataIndex,
      });
    }
</script>
<style lang="less">
.w1352 {
  width: 1190px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
@keyframes showBottom {
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes hideBottom {
  to {
    opacity: 0;
    transform: translateY(100px);
  }
}
</style>
<style lang="less" scoped>
  
    .echartbox{
        height: 570px;
    }
    .echartbox,.echartbox1{
        width: 1200px;
    // height: 458px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.03);
        border-radius: 15px 15px 15px 15px;
        opacity: 1;
        border: 1px solid #EFEFEF;
        margin: 0 auto;
        margin-top: 50px;
        padding: 0;
    }
    @keyframes showLeft {
        to {
            opacity: 1;
            transform: translateX(0px);
        }
    }
    @keyframes showRight {
        to {
            opacity: 1;
            transform: translateX(0px);
        }
    }
    @keyframes hideLeft {
        to {
            opacity: 0;
            transform: translateX(-100px);
        }
    }
    @keyframes hideRight {
        to {
            opacity: 0;
            transform: translateX(100px);
        }
    }
    @keyframes scaleUp-animation {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.25);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes scaleDown-animation {
        0% {
            transform: scale(1.25);
        }
        50% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.25);
        }
    }
    .scale {
    }
    .scale :hover {
        transform: rotate(7deg);
        -ms-transform: rotate(7deg); /* IE 9 */
        -moz-transform: rotate(7deg); /* Firefox */
        -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
        -o-transform: rotate(7deg); /* Opera */
        color: red;
    }

    li {
        list-style: none;
    }
    .Intro{
        background: url("../../../assets/pc/intro/back.png") no-repeat center/100%
        100%;
        background-size: 100%;
        height: 1760px;
    }
    .Intro1{
        margin-top: -577px;
        padding-bottom: 200px;
    // background: #FFFFFF;
    }
    .Intro,.Intro1 {
        text-align: center;
        width: 100%;
    /*// background: url("../../../assets/pc/intro/back.png") no-repeat center/100%*/
    /*//   100%;*/
    /*// background-size: 100%;*/
    /*    color: #000000;*/
    /*// background-position: 0 180%;*/
    /*//padding-bottom: 200px;*/
    .swiper {
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .img1 {
        background: url("../../../assets/pc/intro/Air-drop activity obtains rewards.png")
        no-repeat;
    }
    .img1:hover {
        background: url("../../../assets/pc/intro/Air-drop activity obtains rewards2.png")
        no-repeat;
    }
    .img2 {
        background: url("../../../assets/pc/intro/Operation nodes obtain rewards.png")
        no-repeat;
    }
    .img2:hover {
        background: url("../../../assets/pc/intro/Operation.png") no-repeat;
    }
    .img3 {
        background: url("../../../assets/pc/intro/Staking obtain rewards.png")
        no-repeat;
    }
    .img3:hover {
        background: url("../../../assets/pc/intro/Staking.png") no-repeat;
    }
    .img4 {
        background: url("../../../assets/pc/intro/Contribute code obtain rewards.png")
        no-repeat;
    }
    .img4:hover {
        background: url("../../../assets/pc/intro/Contribute.png") no-repeat;
    }
    .img5 {
        background: url("../../../assets/pc/intro/Secondary market purchase.png")
        no-repeat;
    }
    .img5:hover {
        background: url("../../../assets/pc/intro/Secondary.png") no-repeat;
    }
    .img1,
    .img2,
    .img3,
    .img4,
    .img5:hover {
    .level4title:hover {
        font-size: 22px;
        font-family: Poppins-SemiBold, Poppins;
        font-weight: 600;
        color: #1a1a2c;
        line-height: 37px;
        -webkit-background-clip: text;
    }
    }
    .swiper-slide:hover {
        width: 395px !important;
        background-size: 440px 100%;
        background-position: -25px -30px;
    }
    .swiper-slide {
        width: 395px !important;
        height: 320px !important;
        background-size: 440px 100%;
        background-position: -25px -30px;
    }
    .swiper-slide-active {
    }
    .swiper-slide-prev,
    .swiper-slide-next {
    }
    .tit2{
        padding-top:0px !important;
    }
    .tit1{
        padding-top: 0px !important;
    }
    .title {
        padding-top: 231px;
        margin: 0 auto;
        width: 1200px;
    .BigTitle {
        text-align: left;
        height: 103px;
        font-size: 80px;
        font-family: Poppins-Black, Poppins;
        font-weight: 900;
        color: #000000;
        line-height: 103px;
        -webkit-background-clip: text;
    }
    .SubTitle {
        padding-top: 45px;
        text-align: left;
        height: 36px;
        font-size: 24px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        -webkit-background-clip: text;
        margin-bottom: 22px;
    }
    .SubTitle1{
        margin-top: 100px;
        margin-bottom: 50px;
    }
    .detail {
        padding-top: 22px;
        height: 90px;
        margin: 0 auto;
        text-align: left;
        font-size: 18px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #61666b;
        line-height: 30px;
        -webkit-background-clip: text;
    }
    }
    .echartcontent{
    // padding-top: 50px;
        margin: 0 auto;
        width: 1200px;


    }
    .eco{
        height: 560px;
    //  border: 1px solid red;
        padding-bottom: 100px;
    }
    .eco1{
        height: 650px;
    }
    .box-card {
        position: relative;
        display: flex;
        margin: 0 auto;
        padding-bottom: 157px;
        margin-top: 120px;
    .item {
        width: 395px !important;
        height: 260px !important;
        border-radius: 20px;
        font-size: 0;
        cursor: pointer;
    p {
        font-size: 22px;
        font-weight: 600;
    }
    }
    .item:hover {
        color: #1a1a2c;
    }
    .level4title {
        margin-top: -14px;
        margin-left: 22px;
        padding-right: 110px;
    // width: 274px;
        height: 74px;
        text-align: left;
        font-size: 22px;
        font-weight: 600;
        color: #1a1a2c;
        // color: rgba(26, 26, 44, 0.4);
        line-height: 37px;
        -webkit-background-clip: text;
        font-family: Poppins-SemiBold, Poppins;
    }
    .pr::-webkit-scrollbar {
        display: none;
    }
    .btn {
        text-align: center;
        padding-bottom: 5px;
    }
    }
    .box-card:hover {
        font-size: 22px;
        font-weight: 600;
        color: rgba(26, 26, 44, 0.4);
        line-height: 37px;
    }
    .button-all {
        width: 100%;
        height: 84px;
        position: absolute;
        top: 401px;
        left: 0;
        z-index: 1;
    .swiper-button-prev {
        bottom: 90px;
        width: 84px;
        height: 84px;
        border-radius: 50%;
        background-color: #e2eaff;
        // background: url("../../../assets/pc/intro/Group 2228.png") no-repeat;
         background: url("../../../assets/pc/intro/Group 2225.png") no-repeat;
        color: #fff;
        float: left;
        cursor: pointer;
    }
    .swiper-button-next {
        width: 84px;
        height: 84px;
        border-radius: 50%;
        background-color: #e2eaff;
        color: #fff;
        // background: url("../../../assets/pc/intro/Group 2226.png") no-repeat;
        background: url("../../../assets/pc/intro/Group 2227.png") no-repeat;
        float: left;
        margin-left: 60px;
        cursor: pointer;
    }
    .swiper-button-prev:hover {
        background: url("../../../assets/pc/intro/Group 2225.png") no-repeat;
        cursor: pointer;
    }
    .swiper-button-next:hover {
        background: url("../../../assets/pc/intro/Group 2227.png") no-repeat;
        cursor: pointer;
    }
    }
    .dianji-all {
        width: 790px;
        height: 260px;
        position: absolute;
        top: 0;
        right: 0;
        margin-bottom: 300px;
    }
    }
</style>
